import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

const SliderStyles = ({ children }: PropsWithChildren) => (
  <Box
    sx={{
      "& .alice-carousel .animated": { animationFillMode: "both" },
      "& .alice-carousel .animated-out": { zIndex: 1 },
      "& .alice-carousel .fadeOut": { animationName: "fadeOut" },
      "@keyframes fadeOut": {
        "0%": { opacity: 1 },
        "100%": { opacity: 0, visibility: "hidden" },
      },
      "& .alice-carousel": {
        position: "relative",
        width: "100%",
        direction: "ltr",
        padding: "0 2em",
        boxSizing: "border-box",
      },
      "& .alice-carousel__wrapper": {
        position: "relative",
        overflowX: "hidden",
        overflowY: "hidden",
        boxSizing: "border-box",
        width: "100%",
        height: "auto",
      },
      "& .alice-carousel__stage": {
        position: "relative",
        boxSizing: "border-box",
        width: "100%",
        height: "100%",
        margin: "0",
        padding: "0",
        whiteSpace: "nowrap",
        transformStyle: "flat",
        WebkitTransformStyle: "flat",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
      },
      "& .alice-carousel__stage-item": {
        position: "relative",
        display: "inline-block",
        padding: "0",
        margin: "0",
        boxSizing: "border-box",
        width: "100%",
        verticalAlign: "top",
        whiteSpace: "normal",
        flexShrink: 0,
        "& > div": {
          height: "100%",
        },
      },
      "& .alice-carousel__stage-item.__hidden": {
        opacity: 0,
        overflow: "hidden",
      },
      "& .alice-carousel__prev-btn,\n.alice-carousel__next-btn": {
        position: "absolute",
        top: 0,
        height: "100%",
        display: "flex",
        alignItems: "center",
      },
      "& .alice-carousel__prev-btn [data-area]::after,\n.alice-carousel__next-btn [data-area]::after":
        {
          position: "relative",
          content: "attr(data-area)",
          textTransform: "capitalize",
        },
      "& .alice-carousel__prev-btn": { left: 0 },
      "& .alice-carousel__next-btn": { right: 0 },
      "& .alice-carousel__prev-btn-item,\n.alice-carousel__next-btn-item": {
        display: "inline-block",
        cursor: "pointer",
        padding: "5px",
        margin: "0",
      },
      "& .alice-carousel__prev-btn-item.__inactive,\n.alice-carousel__next-btn-item.__inactive":
        {
          opacity: 0.4,
          pointerEvents: "none",
        },
      "& .alice-carousel__play-btn": {
        position: "absolute",
        top: "30px",
        left: "20px",
        display: "inline-block",
      },
      "& .alice-carousel__play-btn:hover": { cursor: "pointer" },
      "& .alice-carousel__play-btn-wrapper": {
        position: "relative",
        width: "32px",
        height: "32px",
        padding: "10px",
        borderRadius: "50%",
        backgroundColor: "#fff",
      },
      "& .alice-carousel__play-btn-item": {
        position: "absolute",
        width: "32px",
        height: "32px",
        cursor: "pointer",
        border: "0",
        outline: "none",
        background: "transparent",
      },
      "& .alice-carousel__play-btn-item::before, .alice-carousel__play-btn-item::after":
        {
          position: "absolute",
          pointerEvents: "none",
          display: "block",
          width: "0",
          height: "0",
          content: '""',
          transition: "all 0.4s linear",
          borderWidth: "8px 0 8px 15px",
          borderStyle: "solid",
          borderColor: "transparent",
          borderLeftColor: "#465798",
        },
      "& .alice-carousel__play-btn-item::before": {
        left: "5px",
        height: "14px",
      },
      "& .alice-carousel__play-btn-item::after": { top: "7px", left: "18px" },
      "& .alice-carousel__play-btn-item.__pause::before, .alice-carousel__play-btn-item.__pause::after":
        {
          height: "30px",
          borderWidth: "0 0 0 10px",
        },
      "& .alice-carousel__play-btn-item.__pause::after": {
        top: "0",
        left: "18px",
      },
      "& .alice-carousel__dots": {
        margin: "30px 3px 5px",
        padding: "0",
        listStyle: "none",
        textAlign: "center",
      },
      "& .alice-carousel__dots > li": { display: "inline-block" },
      "& .alice-carousel__dots-item:not(.__custom)": {
        width: "8px",
        height: "8px",
        cursor: "pointer",
        borderRadius: "50%",
        backgroundColor: "#e0e4fb",
      },
      "& .alice-carousel__dots-item:not(.__custom):not(:last-child)": {
        marginRight: "20px",
      },
      "& .alice-carousel__dots-item:not(.__custom):hover, .alice-carousel__dots-item:not(.__custom).__active":
        {
          backgroundColor: "#6e7ebc",
        },
      "& .alice-carousel__slide-info": {
        position: "absolute",
        top: "20px",
        right: "20px",
        display: "inline-block",
        padding: "5px 10px",
        color: "#465798",
        borderRadius: "5px",
        backgroundColor: "rgba(224, 228, 251, 0.6)",
      },
      "& .alice-carousel__slide-info-item": {
        verticalAlign: "middle",
        lineHeight: 0,
      },
    }}
  >
    {children}
  </Box>
);

export default SliderStyles;
